import React from "react"
import { Link, graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import "../styles/index.css"

const BlogIndex = ({ data, location }) => {
  const siteTitle = data.site.siteMetadata.title
  const posts = data.allMarkdownRemark.edges
  return (
    <Layout location={location} title={siteTitle} heading="Trong này chả có gì để đọc">
      <SEO title="Trang Chủ" />
      <section class="post-feed">
      {posts.map(({ node }) => {
        const title = node.frontmatter.title;
        const date= node.frontmatter.date;
        const slug=node.fields.slug;
        return (
          <div class="post-card">
            <article key={node.fields.slug}>
             <figure class="post-thumbnail">
             <Link to={slug}>
             <img src={node.frontmatter.featuredImage}
                  onFocus={()=>0}
                  onBlur={()=>0}
                  onMouseOver={e=>(e.currentTarget.src=
                    (node.frontmatter.gifImage === "") ? 
                    node.frontmatter.featuredImage : node.frontmatter.gifImage)}
                  onMouseOut={e=>(e.currentTarget.src=node.frontmatter.featuredImage)}
                  role="presentation" alt="thumbnail"/>
             </Link>
             </figure>
             <div class="post-content">
              <time class="post-date">{date}</time>
                <h2 class="post-title">
                <Link to={slug}>{title}</Link>
                </h2>
               
             </div>               
            </article>
          </div>
        )
      })}
      </section>
    </Layout>
  )
}

export default BlogIndex

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "DD.MM.YYYY")
            title
            description
            featuredImage
            gifImage                  
          }
        }
      }
    }
  }
`
